<template>
  <div class="accordion" v-if="offers.length || (phone.fraxio && phone.fraxio.mentionsLegales) || phone.defaults.insurance || phone.defaults.subscription">
    <div class="name" :class="{ 'closed': !open }" @click="toggle">
      <p>Mentions légales</p>
      <div class="arrow">
        <span class="fi-rr-angle-up" v-if="open"></span>
        <span class="fi-rr-angle-down" v-if="!open"></span>
      </div>
    </div>
    <AccordionItem :data="phone.fraxio" :subscription="false" :insurance="false" v-if="phone.fraxio && phone.fraxio.mentionsLegales && open"/>
    <AccordionItem :data="phone.defaults.insurance" :subscription="false" :insurance="true" v-if="phone.defaults.insurance && phone.defaults.insurance.mentionsLegales && open"/>
    <AccordionItem :data="phone.defaults.subscription" :subscription="true" :insurance="false" v-if="phone.defaults.subscription && phone.defaults.subscription.mentionsLegales && open"/>
    <AccordionItem v-for="(offer, index) in offers" :subscription="false" :insurance="false" :key="index" :data="offer" v-if="open"/>
  </div>
</template>

<script>
import AccordionItem from './AccordionItem'

import { mapState } from 'vuex'

export default {
  name: 'Accordion',
  data () {
    return {
      open: false
    }
  },
  computed: {
    ...mapState({
      phone: state => state.phone.item,
      loading: state => state.phone.loading
    }),
    offers () {
      const offers = []
      if(this.phone.offers && this.phone.offers.length) {
        this.phone.offers.forEach((offer) => {
          offers.push(offer)
        })
      }
      return offers
    }
  },
  methods: {
    toggle() {
      this.open = !this.open
    }
  },
  components: {
    AccordionItem
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../scss/tools/*';
@import '../../../../scss/mixins/*';

.accordion{
  grid-column: span 2;
  margin-top: 40px;
  background-color: darken($white, 5%);
  @include radius(10px);

  .name{
    padding: 20px 30px 10px 30px;
    position: relative;
    cursor: pointer;
    font-weight: $fontSemiBold;

    &.closed{
      padding: 20px 30px;

      .arrow{
        line-height: 32px;
        margin-top: -15px;
      }
    }

    .arrow{
      width: 30px;
      height: 30px;
      text-align: center;
      line-height: 30px;
      background-color: darken($white, 9%);
      color: $black;
      font-size: 14px;
      position: absolute;
      top: 50%;
      margin-top: -10px;
      right: 20px;
      @include radius(100%);
    }
  }
}
</style>
